import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_REGIONAL_MANAGERS = '@regional-managers/get-regional-managers';
export const REQUEST_REGIONAL_MANAGERS = '@regional-managers/request-regional-managers';

export function getRegionalManagers() {
  const request = axios.get(`${API_BASE_URL}/regional-managers`);

  return (dispatch) => {
    dispatch({ type: REQUEST_REGIONAL_MANAGERS });

    request
      .then((response) =>
        dispatch({
          type: GET_REGIONAL_MANAGERS,
          payload: {
            items: response.data,
            total: response.data.total
          }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }

        dispatch({
          type: GET_REGIONAL_MANAGERS,
          payload: { items: [], total: 0, message }
        });
      });
  };
}
